<template>
  <!-- 收藏统计 -->
  <div class="ordersellAnalysis">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['数据分析', $route.meta.title]"
    >
      <!-- <template slot="controls">
        <el-button type="primary" icon="el-icon-download" @click="exportData"
          >导出数据</el-button
        >
      </template> -->
    </crumbs-bar>
    <!-- 搜索框 -->
    <el-scrollbar class="scrollbar">
      <div class="orderTable">
        <div class="table" v-for="(item, index) in tableData" :key="index">
          <div class="orderTableTitle">{{ item.DateType }}</div>
          <div>
            <div class="trHaed">
              <p>订单数</p>
              <p>已出库订单数</p>
              <p>待出库订单</p>
              <p>注册用户</p>
              <p>购买用户</p>
            </div>
            <div class="trHaedtd">
              <p>{{ item.OrderNum }}</p>
              <p>{{ item.OutOrderNum }}</p>
              <p>{{ item.UndeliveredOrdersNum }}</p>
              <p>{{ item.RegisteredUserNum }}</p>
              <p>{{ item.PurchasingUser }}</p>
            </div>
          </div>
          <div>
            <div class="trHaed trHaedheq">
              <p>汇总金额</p>
              <p v-for="(it, i) in item.ClientTypeSales" :key="i">
                {{ it.ClientType }}金额
              </p>
            </div>
            <div class="trHaedtd trHaedtd1">
              <p>{{ item.allMone }}</p>
              <p v-for="(itq, i) in item.ClientTypeSales" :key="i">
                {{ itq.TotalSalesAmount }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  name: "ordersellAnalysis",
  data() {
    return {
      /**表格数据 */
      tableData: [],
      /**搜索表单 */
      searchForm: {
        start: "",
        type: "0",
        end: "",
        name: "",
      },
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      allMone: 0,
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    /**获取表格数据 */
    getTableData() {
      this.$request({
        method: "post",
        url: "/Management/DataAnalysisAdmin/GetOrderSalesDataStatistics",
      })
        .then((res) => {
          if (res.success) {
            this.tableData = res.dataList;
            this.tableData.forEach((i) => {
              i.allMone = 0;
              i.ClientTypeSales.forEach((j) => {
                i.allMone += j.TotalSalesAmount;
              });
              i.allMone = i.allMone.toFixed(2);
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
  },
};
</script>

<style scoped>
.scrollbar {
  height: calc(100% - 60px);
}
.ordersellAnalysis {
  width: 100%;
  height: 100%;
}
.orderTable {
  padding: 20px 20px;
  overflow-y: auto;
}
.orderTableTitle {
  text-align: center;
  padding: 10px 0;
  background: #f6f8fa;
  color: #222222;
  font-size: 20px;
  border-top: 1px solid #d7d9db;
  border-left: 1px solid #d7d9db;
  border-right: 1px solid #d7d9db;
}
.table {
  margin-bottom: 20px;
}
.trHaed {
  display: flex;
  background: #f6f8fa;
  border: 1px solid #d7d9db;
}
.trHaedheq {
  border-top: none !important;
}
.trHaedheq p {
  width: 25% !important;
  border-top: none !important;
}
.trHaedtd1 p {
  width: 25% !important;
}
.trHaed p {
  width: 20%;
  padding: 8px 0;
  text-align: center;
  font-size: 16px;
  border-left: 1px solid #d7d9db;
}
.trHaedtd {
  display: flex;
  text-align: center;
  border-right: 1px solid #d7d9db;
  border-bottom: 1px solid #d7d9db;
}
.trHaedtd p {
  width: 20%;
  text-align: center;
  font-size: 18px;
  padding: 8px 0;
  border-left: 1px solid #d7d9db;
}
.trHaedtd1 p {
  color: #fb845b;
}
</style>
